import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnChanges, SimpleChange, SimpleChanges, ɵɵNgOnChangesFeature } from '@angular/core';
import { getDocumentNumber, mongoId } from '../../../../@core/common/global';
import { ApiService } from '../../../../@core/service/api.service';
import { SharedDataService } from '../../../../@core/service/shared-data.service';
import { TreeService } from '../../../../@core/service/tree.service';
import { CompilationModel } from '../../../../@models/erp/compilation';
import { CompilationTypeData, DocumentStatusData, UnitData } from '../../../../@models/erp/compilationData';
import { FinishedProductModel } from '../../../../@models/erp/finishedProduct';
import { DocumentSelectComponent } from './document-select.component';
import { AbstractItemType } from '../../abstractItem';
import moment from 'moment';

@Component({
  selector: 'ngx-document-of-selector',
  templateUrl: '../document-select/document-select.component.html',
  styleUrls: ['../document-select/document-select.component.scss'],
})
export class DocumentOfSelectorComponent extends DocumentSelectComponent implements OnChanges {

  constructor(private datePipe: DatePipe, public api: ApiService, public data: SharedDataService, public tree: TreeService) {
    super(data);
    this.showBusinessInput = true;
    this.title = 'Quote Selection';
  }

  preFilter(items: CompilationModel[]): CompilationModel[] {
    if (!items) return [];
    const res = [];
    for (const item of items) {
      item.lineItems.forEach((li, idx) => { // unwind lineItems
        const copy = Object.assign({
          productName: this.data?.getFinishedProductString(li.finishedProduct),
          pos: idx+1,
        }, item);
        res.push(copy);
      })
    }
    return res /*
      .filter(f => 
        f.documentStatus === DocumentStatusData.get('final').id
        && mongoId(f.recipient) === mongoId(this.businessId)
      )
      .sort((a, b) => moment(b.issueDate).diff(moment(a.issueDate)));*/
  }

  // preFilter(items: CompilationModel[]): CompilationModel[] {
  //   console.log(items);
  //   return items.sort((a, b) => moment(b.issueDate).diff(moment(a.issueDate)));
  // }
  
  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes.businessId) {
      this.businessId = mongoId(changes.businessId.currentValue);
      if (!this.initialItems?.length) {
        await this.data.loadProducts();
        await this.data.loadBusinesses();
        this.initialItems = this.preFilter(
          (await this.api.getAllVersionData(
            false,
            true,
            [
              'code', 'version', 'draft', 'documentStatus', 'nameOverride', 'lineItems.finishedProduct', 
              // 'lineItems.quantity', 'lineItems.piecePrice', 'lineItems.displayUnit',
              'completelyInvoiced', 'issueDate', 'rfqReference'
            ],
            '^(OFNRKA)',
          )) as CompilationModel[]
        );
      }
      this.init();
    }
  }

  init() {
    this.latestVersionItems = ([...this.initialItems] as CompilationModel[])
      .filter(f => 
        f.documentStatus === DocumentStatusData.get('final').id
        && (mongoId(f.recipient) === mongoId(this.businessId) || !this.businessId)
      )
      .sort((a, b) => moment(b.issueDate).diff(moment(a.issueDate)));
    this.onFilter();
  }

  columns = [
    // { id: 'completelyInvoiced', title: 'INV', search: '' },
    { id: 'issueDate', title: 'Issue date', search: '', type: 'date' },
    { id: 'code', title: 'Offer #', search: '' },
    { id: 'pos', title: 'Pos', search: '' },
    { id: 'rfqReference', title: 'RFQ #', search: '' },
    // { id: 'productCode', title: 'Product Code', search: '' },
    { id: 'productName', title: 'Product Name', search: '' },
  ]

  getText(col: string, item: CompilationModel) {
    // console.log('getText', col, item[col])
    if (!item) return '';
    switch (col) {
      case 'code': return getDocumentNumber(item);
      case 'issueDate':
        return (item[col] as any)?.replace(/T.*/, '');
      default: return item[col];
    }
  }

  override async onBusinessIdChanged(businessId) {
    this.businessId = businessId;
    this.init();
  }

  // (new CompilationModel()).rfqReference

}

